/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, Message, MessageContent } from 'semantic-ui-react'
import { Title } from './Title'
import { Text } from './Text'
import { List } from './List'
import { ListItem } from './ListItem'
import { useFeatureInfoVisibility } from '../../Home/Margin/hooks/useFeatureInfoVisibility'

const FeatureInfo = ({ featureName, children, ...props }) => {
    const [isVisible, setAndPersistIsVisible] = useFeatureInfoVisibility({key: featureName})

    if (!isVisible) {
        return (
          <Icon
            name="info circle"
            color="blue"
            className={props.className}
            onClick={() => {
                setAndPersistIsVisible(true)
            }}
            css={css`
                cursor: pointer;
            `}
          />
        )
    }

    return (
      <Message
        color="blue"
        icon
        onDismiss={() => {
            setAndPersistIsVisible(false)
        }}
        className={props.className}
      >
          <Icon name="info circle"/>
          <MessageContent>
              {children}
          </MessageContent>
      </Message>
    )
}

FeatureInfo.Title = Title
FeatureInfo.Text = Text
FeatureInfo.List = List
FeatureInfo.ListItem = ListItem

export { FeatureInfo }
